<template>
	<div
		class="new-notification"
		v-if="messageBoxShow.length > 0 && !tourGuideShow"
	>
		<transition-group name="list" tag="div">
			<div
				class="action-item item-notificaiton"
				v-for="(item, index) in messageBoxShow"
				@click="redirectLink(item)"
				:key="index"
			>
				<div class="icon-action">
					<div class="mi mi-32 mi-notification-message"></div>
				</div>
				<div class="nofication-content">
					<div class="action-text">{{ item.Content }}</div>
					<div class="nofication-time" v-if="item.ReceivedDate">
						{{ item.ReceivedDate | formatFromNow }}
					</div>
				</div>
			</div>
		</transition-group>
	</div>
</template>
<<script>

import { mapGetters, mapActions } from 'vuex';
import {
	ModuleNotification,
	ModuleLicenseInfo
} from '../../store/module-const';
export default {
	name:"msMessageNotification",
    data() {
		return {
			listNewNotification: [],
			messageBoxShow: []
		};
    },
	computed: {
		...mapGetters(ModuleNotification, [
			'NotificationList'
		]),
		...mapGetters(ModuleLicenseInfo, ['LicenseInfo', 'LicenseWarning']),
		tourGuideShow()
		{
			return this.$store.state.tourGuideRunning;
		},
		isShowHeaderLicense(){
			const me = this;
			return me.LicenseInfo.Status &&
				me.LicenseWarning &&
				me.LicenseWarning.IsShowWarningBanner;
		}
	},
	methods:{
		iconMessage(item)
		{
			if(item.Type == "Notification")
			{
				return `mi-notification-message`;
			}
			return `mi-notification-invoice`;
		},
	}
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';
@media screen and (max-width: 1366px) {
	@import '@/assets/scss/_sm-variables.scss';
	@import '@/assets/scss/views/navbar/messageNotification.scss';
}
@media screen and (min-width: 1367px) {
	@import '@/assets/scss/_variables.scss';
	@import '@/assets/scss/views/navbar/messageNotification.scss';
}
</style>